var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.vastgoedservice, function (dienst, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass:
            "d-flex flex-column custom-dropdown-item justify-content-between mb-15",
        },
        [
          _c(
            "a",
            {
              staticClass: "d-flex service-item",
              attrs: { href: "/diensten/" + dienst.slug },
            },
            [
              dienst.logo
                ? _c("img", {
                    attrs: {
                      src: dienst.logo.guid,
                      alt: dienst.title.rendered,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "m-0 ml-15 service-item",
                  class: [
                    _vm.activeLink === dienst.title.rendered.toLowerCase()
                      ? "activeClass"
                      : "",
                  ],
                },
                [_vm._v(_vm._s(dienst.title.rendered))]
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }